import { useState } from "react";
import CryptoJS from "crypto-js";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Import your privacy settings component
import ProfilePrivacySettings from "../ProfilePrivacySettings"; // Adjust path if needed

// AES constants
const AES_KEY = "7D3B8E69F1A84B7EA8A3F6792B44C926";
const AES_IV = "A1B2C3D4E5F60718";

// Decrypt function
const decryptText = (encryptedText) => {
  const key = CryptoJS.enc.Utf8.parse(AES_KEY);
  const iv = CryptoJS.enc.Utf8.parse(AES_IV);
  const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

function PlatformSettings() {
  let studentId = null;
  let token = null;

  const encrypted = localStorage.getItem("UserLogDetails"); 
  if (encrypted) {
    const decryptedUser = decryptText(encrypted);
    if (decryptedUser) {
      const parsed = JSON.parse(decryptedUser);
      studentId = parsed.StudentId;
      token = parsed.Token;
    }
  }

  return (
    <Card sx={{ boxShadow: "none" }}>
      
      {studentId && token ? (
        <ProfilePrivacySettings studentId={studentId} token={token} />
      ) : (
        <MDBox p={2}>
          <MDTypography color="error">Session expired or user not found.</MDTypography>
        </MDBox>
      )}
    </Card>
  );
}

export default PlatformSettings;
